$(window).on("load", function() {
  // Select only product gallery links
  const $galleryLinks = $('.media-gallery--carousel a');

  // Add data-fancybox attribute
  $galleryLinks.attr('data-fancybox', 'product-images');

  // Add data-thumb for each image (required for thumbnails)
  $galleryLinks.each(function() {
    const $img = $(this).find('img');
    $(this).attr('data-thumb', $img.attr('src'));
  });

  // Bind Fancybox to gallery links
  Fancybox.bind('[data-fancybox="product-images"]', {
    Thumbs: {
      autoStart: true, // show thumbnails
      axis: 'x'        // horizontal
    },
    Toolbar: {
      display: ["zoom", "close", "slideShow", "thumbs"]
    },
    loop: false,
    protect: true,
  });
});
